<script setup lang="ts">
import type { Ref } from "vue";

import { provide, ref, watch } from "vue";

import { useLayout } from "@/layout/common/composables/layout";

const props = defineProps({
  collapsible: {
    type: Boolean,
    default: false,
  },
  class: {
    type: String,
    default: "",
  },
});

const { layoutConfig } = useLayout();
const isOpen = ref(false);

export interface MenuContext {
  collapsible: boolean;
  isOpen: Ref<boolean>;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

const menuContext: MenuContext = {
  collapsible: props.collapsible,
  isOpen,
  toggle: () => {
    menuContext.isOpen.value = !menuContext.isOpen.value;
  },
  open: () => {
    menuContext.isOpen.value = true;
  },
  close: () => {
    menuContext.isOpen.value = false;
  },
};

watch(
  () => layoutConfig.menuState,
  (newState) => {
    if (newState === "collapsed") {
      menuContext.close();
    }
  },
);

provide("menuContext", menuContext);
</script>

<template>
  <li
    :data-menu-collapsible="props.collapsible"
    class="group/menu-item relative"
    :class="props.class"
  >
    <slot />
  </li>
</template>
